module.exports = __webpack_public_path__ + "img/first_fr.1c14df6a.jpg";